import { render } from "./FederationList.vue?vue&type=template&id=2bca3286&ts=true"
import script from "./FederationList.vue?vue&type=script&lang=ts"
export * from "./FederationList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__